import { X } from "lucide-react";
import LeadForm from "./LeadForm";

export default function LeadModal({ lead, onClose, onSaved, onDeleted, onRefresh }) {
  const isEdit = !!lead;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={onClose}>
      <div
        data-testid="lead-form-modal"
        className="bg-[#131C31] w-full max-w-2xl rounded-2xl border border-slate-800 shadow-2xl max-h-[92vh] overflow-y-auto animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800 sticky top-0 bg-[#131C31] z-10">
          <h2 className="font-display font-bold text-xl">{isEdit ? "Edit Lead" : "New Lead"}</h2>
          <button data-testid="close-modal-button" onClick={onClose} className="text-slate-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        <LeadForm
          lead={lead}
          mode="modal"
          onSaved={onSaved}
          onDeleted={onDeleted}
          onRefresh={onRefresh}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}
